export default (date: Date) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  const newDate = new Date(date);
  return new Intl.DateTimeFormat("de-DE", options).format(newDate);
};
